// import { FormRowSelect, FormRow } from '../../components';
// import PropTypes from 'prop-types';

// const GeneralMessageDetails = ({ formData, handleInputChange }) => {
//   const { generalMessageDetails = {} } = formData;

//   return (
//     <>
//       <FormRow
//         type="text"
//         name="generalMessageDetails.text"
//         labelText="תוכן ההודעה"
//         defaultValue={generalMessageDetails.text || ""}
//         handleChange={handleInputChange}
//       />

//       <FormRowSelect
//         labelText="אפשרות הודעה"
//         name="generalMessageDetails.messageOption"
//         defaultValue={generalMessageDetails.messageOption || ""}
//         handleChange={handleInputChange}
//         list={["קבועה", "בין תאריכים"]}
//       />

//       {generalMessageDetails.messageOption === "בין תאריכים" && (
//         <>
//           <FormRow
//             type="date"
//             name="generalMessageDetails.startingDate"
//             labelText="תאריך התחלה"
//             defaultValue={generalMessageDetails.startingDate || ""}
//             handleChange={handleInputChange}
//           />

//           <FormRow
//             type="date"
//             name="generalMessageDetails.expirationDate"
//             labelText="תאריך סיום"
//             defaultValue={generalMessageDetails.expirationDate || ""}
//             handleChange={handleInputChange}
//           />
//         </>
//       )}
//     </>
//   );
// };

// GeneralMessageDetails.propTypes = {
//   formData: PropTypes.object.isRequired,
//   handleInputChange: PropTypes.func.isRequired,
// };

// export default GeneralMessageDetails;



// src/components/messages/GeneralMessageDetails.jsx


import { FormRow, FormRowSelect } from '../../components';
import PropTypes from 'prop-types';

const GeneralMessageDetails = ({ formData, handleInputChange }) => {
  const { text = "", messageOption = "", startingDate = "", expirationDate = "" } = formData;

  return (
    <>
      <FormRow
        type="text"
        name="generalMessageDetails.text"
        labelText="תוכן ההודעה"
        value={text}
        defaultValue={text}
        handleChange={handleInputChange}
      />

      <FormRowSelect
        labelText="אפשרות הודעה"
        name="generalMessageDetails.messageOption"
        list={["קבועה", "בין תאריכים"]}
        value={messageOption}
        defaultValue={messageOption}
        handleChange={handleInputChange}
      />

      {messageOption === "בין תאריכים" && (
        <>
          <FormRow
            type="date"
            name="generalMessageDetails.startingDate"
            labelText="תאריך התחלה"
            value={startingDate}
            defaultValue={startingDate}
            handleChange={handleInputChange}
          />

          <FormRow
            type="date"
            name="generalMessageDetails.expirationDate"
            labelText="תאריך סיום"
            value={expirationDate}
            defaultValue={expirationDate}
            handleChange={handleInputChange}
          />
        </>
      )}
    </>
  );
};

GeneralMessageDetails.propTypes = {
  formData: PropTypes.shape({
    text: PropTypes.string,
    messageOption: PropTypes.string,
    startingDate: PropTypes.string,
    expirationDate: PropTypes.string,
  }).isRequired,
  handleInputChange: PropTypes.func.isRequired,
};

export default GeneralMessageDetails;
